import React from "react";
import { Main } from "pages/_layouts/Main";
import { Timeline } from "./components/Timeline";

export const Novidades: React.FC = () => {
  return (
    <Main
      title="Novidades e Atualizações"
      subtitle="Fique por dentro das últimas melhorias do sistema"
    >
      <Timeline />
    </Main>
  );
};
